import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { LABEL_FRAGMENT } from './label'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const REFRESHER_FRAGMENT: TypedDocumentNode<AbTestsParametersSchemaDTO['refresher']> = gql`
  ${LABEL_FRAGMENT}

  fragment refresherFragment on AbTestsParametersRefresher {
    basicSettings {
      ...labelFragment
    }
    label
  }
`
